import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import GLightbox from 'glightbox';

document.addEventListener('DOMContentLoaded', () => {
  const projectsSlider = document.querySelector('.projects-swiper');

  if (projectsSlider) {
    // Initialize Swiper
    const swiper = new Swiper(projectsSlider, {
      modules: [Navigation, Pagination],
      slidesPerView: 1.2,
      spaceBetween: 32,
      centeredSlides: false,
      loop: false,
      navigation: {
        nextEl: '.projects-slider__nav--next',
        prevEl: '.projects-slider__nav--prev',
      },
      pagination: {
        el: '.projects-slider__dots',
        clickable: true,
      },
      breakpoints: {
        600: {
          slidesPerView: 1.6,
        },
        800: {
          slidesPerView: 2.2,
        },
        980: {
          slidesPerView: 3.2,
        },
        1280: {
          slidesPerView: 4,
        },
      },
    });

    // Initialize GLightbox
    const lightbox = GLightbox({
      selector: '.glightbox',
      touchNavigation: true,
      loop: true,
      autoplayVideos: true,
    });
  }
});
